exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.opacity-10{\n    opacity: 0.15 !important;\n}\n", ""]);

// exports
